// extracted by mini-css-extract-plugin
export default {"agentDealsStats":"agentDealsStats_CCzVg","header":"header_zw9dM","title":"title_Ja3ms"};